import createElement from "../../../../../helpers/createElement";
import {setAsSelect2} from "../../../../../helpers/inputs";

class CustomSelectCellEditor {
	/** @type {HTMLElement} */
	guiElement;
	/** @type {HTMLSelectElement} */
	selectInput;

	// noinspection JSUnusedGlobalSymbols
	/**
	 * @param {import('ag-grid-community/dist/lib/interfaces/iCellEditor').ICellEditorParams} params
	 */
	init(params) {
		// Build options
		let optionsString = '';

		// noinspection JSUnresolvedReference
		params.getAvailableOptions(params.data).forEach(option => {
			optionsString += `<option value="${option.value}" ${params.value === option.value ? 'selected' : ''}>${option.text}</option>`
		})

		this.guiElement = createElement(`
			<div class="form-group m-0">
				<select
					class="form-control form-control-sm"
					name="select"
				>
					${optionsString}
				</select>
			</div>
		`);

		// noinspection JSUnresolvedReference
		const customSelect2Options = params.select2Options ? params.select2Options : {};

		const select2Options = {
			...customSelect2Options,
		};

		this.selectInput = this.guiElement.querySelector('select');

		// Make select2
		setAsSelect2(this.selectInput, select2Options);

		// Add class
		$(this.selectInput).data('select2')
			.$container
			.addClass('ag-custom-select-editor')

		// Stop editing on close
		$(this.selectInput).on('select2:close', () => {
			params.api.stopEditing();
		})
	}

	// after this component has been created and inserted into the grid
	// noinspection JSUnusedGlobalSymbols
	afterGuiAttached() {
		$(this.selectInput).select2('open');
	}

	// Mandatory - Return the DOM element of your editor, this is what the grid puts into the DOM
	// noinspection JSUnusedGlobalSymbols
	getGui() {
		return this.guiElement;
	};

	// Mandatory - Return the final value - called by the grid once after editing is complete
	// noinspection JSUnusedGlobalSymbols
	getValue() {
		return this.selectInput.value;
	};

	// Gets called once after initialised. If you return true, the editor will
	// appear in a popup, so is not constrained to the boundaries of the cell.
	// This is great if you want to, for example, provide you own custom dropdown list
	// for selection. Default is false (ie if you don't provide the method).
	// noinspection JSUnusedGlobalSymbols
	isPopup() {
		return true;
	};

	// Gets called once, only if isPopup() returns true. Return "over" if the
	// popup should cover the cell, or "under" if it should be positioned below
	// leaving the cell value visible. If this method is not present, the
	// default is "over"
	// noinspection JSUnusedGlobalSymbols
	getPopupPosition() {
		return 'over';
	};
}

export {CustomSelectCellEditor}
